
import React, { Component } from 'react' 
import { Link, withRouter } from 'react-router-dom'
import jwt_decode from 'jwt-decode'
import SwitchLabels from './Switch'

class Dash extends Component {

  constructor(props) {
    super()
    this.state = {

      
      username: '',
      email:'',
      firstname:'',
      lastname:'',
      id: '',
      imagescounts:'',
      imagesframe:'',
      errors: {}
    }
  }

  componentDidMount() {
    const token = localStorage.usertoken
    console.log(token)
    const decoded = jwt_decode(token)
    this.setState({
      firstname: decoded.firstname,
      lastname: decoded.lastname,
      username: decoded.firstname + ' ' + decoded.lastname,
      id: decoded.id,
      email: decoded.email,
      imagescounts: decoded.imagescounts,
      imagesframe: decoded.imagesframe
      
    })
  }

  logOut(e){
    e.preventDefault()
    localStorage.removeItem('usertoken')
    this.props.history.push(`/user-login`)
}


  render() {
    const {username, email, id, firstname, lastname, imagescounts, imagesframe} = this.state
    return (
      <div>
          <h2 className="trialuserwel">Welcome {username} to your profile </h2>
          <a href="" onClick={this.logOut.bind(this)} className="logouts">
            Logout
          </a>

          <ul className="userinfo">
            <h1>User Details</h1>
    <li>User ID: <span>{id}</span></li>
    <li>First Name: <span>{firstname}</span></li>
    <li>Last Name: <span>{lastname}</span></li>
    <li>Your Email: <span>{email}</span></li>
    <li>Product Images Per Year: <span>{imagescounts}</span></li>
    <li>Time Period Of Upload: <span>{imagesframe}</span></li>
    
    <li>
     
    </li>
          </ul>
      </div>
 
      
    )
  }
}

export default withRouter(Dash);
